import { toKebabCase } from 'helpers/utils'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import MutedText from './muted-text'

function NumberField({
  title,
  showTitle = true,
  placeholder,
  params,
  accessorKey,
  setParams,
  isActive = false,
  inputTextPosition = 'end',
  isPercent = false
}) {
  const getDisplayValue = (params, accessorKey, isPercent) => {
    const value = params[accessorKey]
    if (value === undefined || value === '') {
      return ''
    }
    return isPercent ? value * 100 : value
  }

  const handleValueChange = (value, isPercent) => {
    if (value === '') {
      return ''
    }
    return isPercent ? value / 100 : value
  }

  return (
    <div>
      <InputGroup className={isActive ? 'border border-primary rounded' : ''}>
        {showTitle && inputTextPosition === 'start' && (
          <InputGroup.Text>
            <MutedText
              as="label"
              style={{
                fontSize: 12,
                color: '#6c757d',
                fontWeight: 300,
                zIndex: 2
              }}
              className="small"
            >
              <small>{title && ' ' + title}</small>
            </MutedText>
          </InputGroup.Text>
        )}
        <Form.Control
          type="number"
          name={toKebabCase(title)}
          placeholder={placeholder}
          value={getDisplayValue(params, accessorKey, isPercent)}
          onChange={(e) => {
            const val = e.target.value
            // Allow empty string, otherwise only allow valid numbers
            if (val === '' || /^-?\d*\.?\d*$/.test(val)) {
              setParams({
                ...params,
                [accessorKey]: handleValueChange(val, isPercent)
              })
            }
          }}
          onKeyDown={(e) => {
            // Allow: backspace, delete, tab, escape, enter, arrows, period, minus
            if (
              [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'Home',
                'End'
              ].includes(e.key)
            ) {
              return
            }
            // Allow one period and one minus at the start
            if (
              (e.key === '.' && e.target.value.includes('.')) ||
              (e.key === '-' &&
                (e.target.selectionStart !== 0 || e.target.value.includes('-')))
            ) {
              e.preventDefault()
            }
            // Block non-numeric
            if (!/[0-9.-]/.test(e.key)) {
              e.preventDefault()
            }
          }}
        />
        {showTitle && inputTextPosition === 'end' && (
          <InputGroup.Text>
            <MutedText
              as="label"
              style={{
                fontSize: 12,
                color: '#6c757d',
                fontWeight: 300,
                zIndex: 2
              }}
              className="small"
            >
              <small>{title && ' ' + title}</small>
            </MutedText>
          </InputGroup.Text>
        )}
      </InputGroup>
    </div>
  )
}

export default NumberField
